import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './index.css'

// Early fetch interception for Capacitor / Mobile Native app
const SERVER_HOST = 'https://rotterdamaurahair.com';
if (typeof window !== 'undefined') {
  const isCapacitorOrLocalhost = (
    window.location.protocol === 'capacitor:' ||
    window.location.protocol === 'file:' ||
    (window.location.hostname === 'localhost' && window.location.port !== '5173')
  );
  if (isCapacitorOrLocalhost) {
    const origFetch = window.fetch;
    window.fetch = function(resource, init) {
      if (typeof resource === 'string' && resource.startsWith('/api/')) {
        resource = SERVER_HOST + resource;
      }
      return origFetch.call(this, resource, init);
    };
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

